import React, { Component } from 'react'
import FormViewer from '../../components/FormViewer'
import { translate } from "../../utils/useful";
import CAHeader from '../../components/header/CAHeader';
import ButtonAnimated from '../../components/buttons/ButtonAnimated';

class CAMessengerType extends Component {

    state = {
        headers: [
            {
                type: 'ImageSelectInput', key: 'frame.mode', information: {
                    col: 3,
                    fontSize: 15,
                    FontWeight: 600,
                    padding: '10px',
                    type: 'local',
                    items: [
                        { title: '{{lang}}Standard', image: '/assets/icons/portals/folder2.svg', value: 'private', description: 'This type can be used as peer to peer and groups messenger' },
                        { title: '{{lang}}ca.Support', image: '/assets/icons/useful/customer-service.png', value: 'support', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit.' },
                        { title: '{{lang}}ca.Broadcast', image: '/assets/icons/useful/broadcast.png', value: 'broadcast', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit.' },
                    ], placeholder: '{{lang}}Select The Hub ...', required: true
                },
            },
        ],
        collectionName: null,
    }

    componentDidMount() {
        let collectionName = this.state.collectionName
        let data = this.props.initData

        if (data.collectionInfo) {

            if (data.collectionInfo.collectionName) {
                collectionName = data.collectionInfo.collectionName
            }
            if (!collectionName) {
                collectionName = translate("Untitled Collection")
            }
        } else {
            collectionName = translate("Untitled Collection")
        }
        this.setState({ collectionName }, () => {
            this.props.setHeader("dummy", 1)
        })
        if (this.props.setHeader) {
            this.props.setHeader({
                'toolbar': null,
                'showToolbar': false,
                isPortal: true, doNotshowNotification: true,
                'title': translate('Create Applet | Messenger Type'),
                create: true,
                topHeaderComponent: this.topHeaderComponent,
                headerIdentityComponent: this.headerIdentityComponent,
                backAction: () => this.props.lastStage()
            })
        }
        console.log('datallll',data)
    }
    
    setName = (value) => {
        this.setState({ collectionName: value }, () => {
            this.props.setHeader("dummy", 1)

        })
    }
    headerIdentityComponent = () => {
        return (
            <div className='' >
                <div className='modern-input-header flexcc blue-box-border-h px-2 py-2 br-10 w-100' style={{ border: 'none' }}>
                    {/* <TextInput data={this.state.collectionName} changeValue={this.changeValue} styleInfo={this.state.styleInfo} header={{ key: 'collectionName', information: { rows: 1, placeholder: '{{lang}}Form Name ...' }, }} /> */}
                    <input onChange={(e) => this.setName(e.target.value)} data={this.state.collectionName} value={this.state.collectionName} className={' ' + this.props.colors?.iconInvert ? 'lightPlaceholder' : 'darkPlaceholder'} style={{ backgroundColor: 'transparent', border: 'none', color: this.props.colors.textColor }} placeholder={translate('Form Name ...')} />

                </div>
            </div>
        )
    }
    setHeader = (key, value) => {
        if (this.header) {
            if (typeof key == 'object') {
                let object = {
                    showSettings: true,
                    showFrames: 'static'
                }
                if (this.props.defaultHeaderConfig) {
                    object = { ...this.props.defaultHeaderConfig }
                }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }
                if (object.showSettings && this.props.showSettings) {
                    object.showSettings = this.props.showSettings
                }
                this.setState({ headerConfig: object }, () => {
                    this.header.forceUpdate()
                })
            }
            else {
                this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
                    this.header.forceUpdate()
                })
            }
        }
    }

    topHeaderComponent = () => {
        return (
            <div className='flexc'>
                <ButtonAnimated
                    iconwidth='24px'
                    isLoading={this.state.isLoading}
                    onClick={this.nextStage}
                    title={translate("ca.Continue")}
                    icon='/assets/icons/angle-right-white2.svg'
                    textColor={'#222'}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                />
            </div>
        )
    }

    nextStage = () => {
        let rawData = this.form.getForm()
        if (this.state.collectionName?.trim() == null || !this.state.collectionName?.trim()) {
            this.setState({ collectionName: null }, () => {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.NameRequired', description: '{{lang}}errors.NameRequired' })

            })
        }
        if (rawData) {
            let data = { frame: { mode: rawData.frame.mode }, collectionInfo: {} }
            data.collectionInfo.collectionName = this.state.collectionName
            this.props.setData(data, () => {
                // this.props.setFrameFields([], 0, () => {
                    // console.log('thisdata',this.props.initData)
                    this.props.continue(this.props.stageName)
                })
            // })
        }
    }


    render() {
        return (
            <div className='h-100 w-100 scroll-no-scrollbar overflow-hidden flexc flex-column ' style={{ position: 'relative', borderBottomRightRadius: '10px' }}>
                <div className='w-100 h-100 position-absolute overflow-hidden' >
                    <div style={{ height: 1500, width: 1500, zIndex: 0, position: 'absolute', top: -50, left: -50, background: 'radial-gradient(67.22% 50% at 50% 50%, rgba(51, 231, 255, 0.15) 0%, rgba(245, 228, 255, 0) 100%)' }}>
                    </div>
                    <div style={{ height: 1500, width: 1500, zIndex: 0, position: 'absolute', top: -100, left: "50%", background: 'radial-gradient(48.02% 35.72% at 50% 50%, rgba(50, 247, 51, 0.15) 0%, rgba(128, 255, 0, 0) 100%)' }}>
                    </div>
                </div>
                {/* <div className='w-100' style={{ position: 'relative', top: 0 }}>
                    <CAHeader ref={el => this.header = el} config={this.state.headerConfig} toolbar={this.state.toolbar} showToolbar={this.state.showToolbar} type={'static'} functionsHandler={this.functionsHandler} page={this.state.page} language={this.props.language} toolbarView={'applet'} headertype={'applet'} headers={this.state.headers} goToHub={this.props.goToHub} backStage={this.backStage} sections={this.state.sections} modules={this.state.modules} changePage={this.changePage} backbtn={this.state.showBackBtn} applet={this.props.applet} width={this.props.width} colors={this.props.colors} features={this.props.applet?.features} />
                </div> */}
                <div className='p-3 w-100' style={{ maxWidth: 800 }}>

                    <div className='px-0 pt-3 mb-3' style={{}}>
                        <h2 className=" text-semibig mb-0 color-dark-blue-1" >{translate('Choose messenger type')}</h2>
                        <p className="mt-1 text-small color-dark-blue-1 max-width-500" >{translate("ca.What type of messenger you are looking after?")}</p>
                    </div>

                    {/* <div className=''>
                        <p className='mt-1 text-small color-dark-blue-1 ' style={{}}>{translate('ca.What type of messenger you are looking after?')}</p>
                    </div> */}
                    <div className='mt-2' >
                        <FormViewer ref={el => this.form = el} initData={this.props.initData} headers={this.state.headers} errors={this.state.errors} inputClass={' single-big  color-dark-blue-1'} nopadding={true} width={this.props.width} />
                    </div>

                </div>
                {/* <div className=" w-100 h-100 scroll-no-scrollbar py-5 position-relative  flex-column" style={{ backgroundColor: '' }}>
                    <div className=' w-100 '>
                        <Responsive width={this.props.width} media={{ xs: "12", md: '12' }}>
                            <div className='px-5  w-100 flexcc  flex-column'>
                                <div style={{ maxWidth: 650 }}>
                                    <div className='flexc'>
                                        <button onClick={() => this.props.lastStage()} className='flexc'>
                                            <div className='rotate-180 bg-dark-blue-1 br-50 ws-25 hs-25 flexcc'>
                                                <img className='invert' src="/assets/icons/useful/angle-right.svg" height={20} />
                                            </div>
                                        </button>
                                        <h2 className=" text-big mb-0 color-dark-blue-1 mx-2" >{translate('ca.Choose Messenger type')}</h2>
                                    </div>
                                    <div >
                                        <p className="mt-1 text-small color-dark-blue-1 " >{translate('ca.What type of messenger you are looking after?')}</p>
                                    </div>
                                    <div className='mt-3' >
                                        <FormViewer ref={el => this.form = el} headers={this.state.headers} initData={this.props.initData} errors={this.state.errors} inputClass={' single-big  color-dark-blue-1'} nopadding={true} />
                                    </div>
                                    <div className='mt-3 px-2'>
                                        <LoaderButton
                                            onClick={() => this.nextStage()}
                                            isLoading={this.state.isLoading}
                                            text={translate("ca.Continue")}
                                            icon={'/assets/icons/angle-right-white2.svg'}
                                            backgroundImage='linear-gradient(45deg, #0094FF 0%, #6100FF 51%, #0094FF  100%)'
                                            className={'button-interactive-1'}
                                            language={this.props.language}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Responsive>
                    </div>
                </div> */}
            </div>
        )
    }
}

export default CAMessengerType;